const checkRoleListContains = (parentArray: any[], subsetArray: any[]) => {
  return subsetArray.some((roleName) => {
    return parentArray.some((role) => role['roleName'] === roleName);
  });
};

export default checkRoleListContains;
